module.exports = __webpack_public_path__ + "img/max-ulichney-believers.b2e5568.jpg";